import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import ThemeContext from "./context/ThemeContext"; 

// Disable wheel event on focused number inputs to prevent accidental changes
document.addEventListener("wheel", function (e) {
  if (document.activeElement && document.activeElement.tagName === "INPUT" && document.activeElement.type === "number") {
    e.preventDefault();
  }
}, { passive: false });

// Inject global style
const fontStyle = document.createElement('style');
fontStyle.innerHTML = `
body {
  font-family: -apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

`;
document.head.appendChild(fontStyle);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeContext>
          <App />
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
